module.exports = __webpack_public_path__ + "static/media/berlin.4ea28db8.jpg";